import { CompanyType } from '../../../types/application/business';

export const BusinessTypesDTO = {
  SOLE_PROP: 'Sole Proprietorship',
  PARTNERSHIP: 'Partnership',
  COMPANY: 'Company',
  CLOSE_CORP: 'Close Corporation',
  NPO: 'NPO',
  TRUST: 'Trust',
  GENERAL: 'General',
};

export function getCompanyTypeFromBusinessTypeDTO(businessType: string): CompanyType | undefined {
  switch (businessType) {
    case BusinessTypesDTO.SOLE_PROP:
      return CompanyType.SOLE_PROP;

    case BusinessTypesDTO.PARTNERSHIP:
      return CompanyType.PARTNERSHIP;

    case BusinessTypesDTO.COMPANY:
      return CompanyType.COMPANY;

    case BusinessTypesDTO.CLOSE_CORP:
      return CompanyType.CLOSE_CORP;

    case BusinessTypesDTO.NPO:
      return CompanyType.NPO;

    case BusinessTypesDTO.TRUST:
      return CompanyType.TRUST;

    case BusinessTypesDTO.GENERAL:
      return undefined;

    default:
      throw new Error(`Integration revamp: unknown company type: ${businessType}`);
  }
}

export function getBusinessTypeDTOFromCompanyType(companyType?: CompanyType): string {
  switch (companyType) {
    case undefined:
      return BusinessTypesDTO.GENERAL;

    case CompanyType.SOLE_PROP:
      return BusinessTypesDTO.SOLE_PROP;

    case CompanyType.PARTNERSHIP:
      return BusinessTypesDTO.PARTNERSHIP;

    case CompanyType.COMPANY:
      return BusinessTypesDTO.COMPANY;

    case CompanyType.CLOSE_CORP:
      return BusinessTypesDTO.CLOSE_CORP;

    case CompanyType.NPO:
      return BusinessTypesDTO.NPO;

    case CompanyType.TRUST:
      return BusinessTypesDTO.TRUST;

    default:
      throw new Error(`Integration revamp: unknown company type: ${companyType}`);
  }
}
